<template>
  <div class="company-details order-mng">
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="row">
        <div class="col-md-10">
          <p>
            <i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('settingCompany.deliveryMethodsReflect')}}<a href="#" @click.prevent="goToCompany()"> {{$t('settingCompany.locationGroups')}}.</a>
          </p>
        </div>
        <div class="col-md-2 text-right">
          <p class="">
            <a class="btn btn-success btn-icon mar-rt-10"  @click.prevent="validate" :title="$t('general.saveChanges')">
              <i class="ti-save"></i>
            </a>
          </p>
        </div>
      </div>
    </div>
    <div ref="compDetailsContainer" class="company-wrap" :style="'height:' + (windowHeight - pageTopHeight - navbarHeaderHeight - 1) + 'px'">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <div class="card mar-to-5">
        <div class="card-content">
          <h5 class="pad-bt-15">
            <i class="ti-align-left"></i>  {{$t('settingCompany.deliveryLabels')}}
          </h5>
          <div class="row">
            <div class="pad-bt-15 col-md-6" v-for="labelObj in model.delivery_options_labels">
              <label > {{$t('settingCompany.' + labelObj['key'])}} </label>
              <input class="form-control"
                      type="text" 
                      v-validate="{required: true}"
                      v-model="labelObj['label']">
            </div>
          </div>
        </div>
      </div>
      <div class="card pad-bt-15" v-for="(bussLocation, indexBussLocation) in model.locations_details">
        <div class="card-content">
          <h5 class="pad-bt-15">
            <i class="ti-home"></i> {{$t('settingCompany.bussLoc')}}: {{bussLocation.name}}
          </h5>
          <form>
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
              <el-collapse v-model="activeNames">
                <template v-for="(order, orderIdx) in bussLocation.ordering_management">
                  <template v-if="model.delivery_options_labels[getObjectByElemKeyValue('key', order.type, model.delivery_options_labels)]">
                  <div class="pull-right disable-chck" @click="updateTabs(bussLocation.id + order.type, order.enabled)">
                    <p-checkbox
                      value="true"
                      v-model="order.enabled"
                      key="order.type"
                      :label="order.label"
                      @click="updateTabs(bussLocation.id + order.type)" 
                     >{{$t('settingsOrdering.enabled')}}</p-checkbox>
                  </div>
                  <el-collapse-item :title="model.delivery_options_labels[getObjectByElemKeyValue('key', order.type, model.delivery_options_labels)]['label']" :name="bussLocation.id + order.type" class="text-left" :class="order.enabled ? '' : 'disabled'">
                    <form>
                      <template v-if="order.type == 'eat_location'">

                        <div class="form-group" >
                          <p-checkbox
                            value="true"
                            v-model="order.reservation_available_in_app"
                            key="order.reservation_available_in_app"
                            :label="order.reservation_available_in_app"
                           >{{$t('settingsOrdering.reservation_available_in_app')}}</p-checkbox>
                        </div>

                        <div class="form-group">
                            <hr>
                        </div>

                        <template v-if="order.reservation_available_in_app">
                          <div class="form-group">
                            <label>Numărul minim de persoane pentru o rezervare</label>  
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'min_reservation'" class="form-control sml" 
                                    v-model="order.min_reservation"
                                    :disabled="!order.enabled"
                                    placeholder=""
                                    v-validate="modelValidate.required">
                          </div>
                          <div class="form-group">
                            <label>Numărul maxim de persoane pentru o rezervare</label>  
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'max_reservation'" class="form-control sml" 
                                    v-model="order.max_reservation"
                                    :disabled="!order.enabled"
                                    placeholder=""
                                    v-validate="modelValidate.required">
                          </div>
                          <div class="form-group">
                            <label>{{$t('settingsOrdering.min_between_reservations')}}</label>
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'min_between_reservations'" 
                                    class="form-control sml"
                                    placeholder=""
                                    :disabled="!order.enabled"
                                    v-model="order.min_between_reservations"
                                    >
                          </div>                          
                          <div class="form-group">
                            <label>{{$t('settingsOrdering.min_standard_reservations')}}</label>
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'min_standard_reservations'" 
                                    class="form-control sml"
                                    placeholder=""
                                    :disabled="!order.enabled"
                                    v-model="order.min_standard_reservations"
                                    >
                          </div>
                          <div class="form-group">
                            <hr>
                          </div>
                          <div class="form-group">
                            <label>{{$t('settingsOrdering.available_days')}}</label>
                            <div class="row" v-for="(day, dayIdx) in order.available_days" style="display: flex; align-items: flex-start;     margin-bottom: 20px;">
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-3 padd in-inline-160">
                                    <div class="checkbox">
                                      <input v-if="dayIdx == 0" type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="bussLocation.id + order.type + 'days'"
                                              :id="bussLocation.id + order.type + day.day"
                                              v-validate="{required: true}"
                                              :disabled="!order.enabled"
                                              >
                                      <input v-else  type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="bussLocation.id + order.type + 'days'"
                                              :id="bussLocation.id + order.type + day.day"
                                              :disabled="!order.enabled"
                                              >
                                      <label :for="bussLocation.id + order.type + day.day">{{$t('days.' + day.day) | capitalize}}</label>
                                    </div>
                                  </div>
                                  <div class="col-md-9 padd">
                                    from
                                    <el-time-select :disabled="!day.open || !order.enabled"
                                                    placeholder="Select time"
                                                    :value="day.open_from"
                                                    v-model="day.open_from"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    to
                                    <el-time-select :disabled="!day.open || !order.enabled"
                                                    placeholder="Select time"
                                                    :value="day.open_to"
                                                    v-model="day.open_to"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                  </div>
                                </div>
                                <div class="row intervals" v-if="day.intervals">
                                  <template v-for="(interval, intervalKey) in day.intervals">
                                    <div class="col-md-3 padd in-inline-160"></div>
                                    <div class="col-md-9 padd">
                                    from
                                    <el-time-select :disabled="!day.open || !order.enabled"
                                                    placeholder="Select time"
                                                    :value="interval.open_from"
                                                    v-model="interval.open_from"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    to
                                    <el-time-select :disabled="!day.open || !order.enabled"
                                                    placeholder="Select time"
                                                    :value="interval.open_to"
                                                    v-model="interval.open_to"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    <button class="btn btn-simple btn-icon " @click.prevent="deleteIntervals(intervalKey, dayIdx, orderIdx, indexBussLocation)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button>
                                  </div>
                                  </template>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <button class="btn btn-info btn-icon "
                                        @click.prevent="addMoreIntervals(dayIdx, orderIdx, indexBussLocation)"
                                        :title="$t('general.add')  + ' moreIntervals'" >
                                  <i class="ti-plus"></i> 
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <hr>
                          </div>
                          <div class="form-group">
                            <div class="form-group">
                              <div class="card" style="box-shadow: none; border: 1px solid #dcdfe6;">
                                <div class="card-content">
                                  <div class="prod-tabs" direction="horizontal" type="tabs">
                                    <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                                      <h6>{{$t('settingsOrdering.reservationTaxesTitle')}}</h6>
                                      <button class="btn btn-info btn-icon "
                                              @click.prevent="addReservationTaxesInfo(indexBussLocation, orderIdx)"
                                              :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                                        <i class="ti-plus"></i>
                                      </button>
                                    </div>
                                    <div class="col-md-12 pad-lf-0 pad-rg-0">
                                      <hr class="sm">
                                    </div>
                                    <div :title="$t('catalogProdOpt.plural')" class="text-left">
                                      <div class="row">

                                        <div class="col-md-12" >
                                          <p v-if="order.reservation_taxes && order.reservation_taxes.length == 0" class="">{{$t('settingsOrdering.reservationTaxesTitleEmpty')}}</p>
                                          <el-collapse ref="elColl" v-model="reservationTaxesIndex" accordion>
                                            <template v-for="(tax, idTax) in order.reservation_taxes">
                                              <div class="align" v-if="!tax.deleted_at">
                                                <el-collapse-item class="customItem" :title="tax.name === '' ? 'Name' : tax.name" :name="idTax">
                                                  <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                                  <div class="row">
                                                    <div class="col-md-12">
                                                      <span>ID: {{tax.id}}</span>
                                                    </div>
                                                    <div class="col-md-12">
                                                      <div class="row">
                                                        <div class="col-md-6">
                                                          <div class="form-group">
                                                            <label>{{$t('catalogProd.name')}}</label>
                                                            <input type="text"
                                                                    name="name"
                                                                    :placeholder="$t('catalogProd.name')"
                                                                    v-validate="'required'"
                                                                    v-model="tax.name"
                                                                    class="form-control">
                                                            <small class="text-danger" v-if="errors.has('name')">
                                                              {{ getError('name') }}
                                                            </small>
                                                          </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                          <div class="form-group">
                                                            <label>{{$t('settingsOrdering.chooseZone')}}</label>
                                                            <select class="form-control" v-model="tax.table_zone_id">
                                                              <option :value="0">{{$t('general.all')}}</option>
                                                              <template v-for="zone in model.table_zones">
                                                                <option :value="zone.id">{{zone.name}}</option>
                                                              </template>
                                                            </select>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="row">
                                                        <div class="col-md-6">
                                                          <div class="form-group">
                                                            <label>{{$t('marketingOffers.startEndDate')}}</label><br>
                                                            <el-date-picker type="date"
                                                                            v-model="tax.date_from"
                                                                            value-format="yyyy-MM-dd"
                                                                            format="dd/MM/yyyy"
                                                                            :picker-options="{
                                                                              disabledDate (time) {
                                                                                if ((time.getTime() + 86401 * 1000) < Date.now()) {
                                                                                  return true
                                                                                } else {
                                                                                  return false
                                                                                }
                                                                              }
                                                                            }">
                                                            </el-date-picker>
                                                            <el-date-picker type="date"
                                                                            v-model="tax.date_to"
                                                                            value-format="yyyy-MM-dd"
                                                                            format="dd/MM/yyyy"
                                                                            :picker-options="pickerOptionsTaxTo">
                                                            </el-date-picker>
                                                          </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                          <div class="form-group">
                                                            <label>{{$t('catalogProd.price')}}</label>
                                                            <input type="number"
                                                                    min="0"
                                                                    name="name"
                                                                    :placeholder="$t('catalogProd.price')"
                                                                    v-validate="'required'"
                                                                    v-model="tax.price"
                                                                    class="form-control">
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </el-collapse-item>
                                                <div class="closeBtn">
                                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteReservationTaxesInfo(indexBussLocation, orderIdx, idTax)"><i class="ti-close"></i></button>
                                                </div>
                                              </div>
                                            </template>
                                          </el-collapse>
                                        </div>
                                        <div class="col-md-12 pad-to-15 pad-bt-10">
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <label>{{$t('settingsOrdering.paymentOptions')}}</label>

                            <div class="checkbox mar-bt-20" v-for="(opt, idx) in paymentOptions">
                              <input v-if="idx == 0" type="checkbox"
                                      :value="opt.payment_id"
                                      :name="bussLocation.id + order.type + 'payment'"
                                      :id="bussLocation.id + order.type + opt.payment_id"
                                      v-validate="{required: true}"
                                      v-model="order.payment_options[opt.payment_id]" 
                                      :disabled="!order.enabled"
                                      >
                              <input v-else  type="checkbox"
                                      :value="opt.payment_id"
                                      :name="bussLocation.id + order.type + 'payment'"
                                      :id="bussLocation.id + order.type + opt.payment_id"
                                      v-model="order.payment_options[opt.payment_id]" 
                                      :disabled="!order.enabled"
                                      >
                              <label :for="bussLocation.id + order.type + opt.payment_id">{{opt.name}}</label>
                            </div>
                            <label class="text-danger" v-show="errors.has(bussLocation.id + order.type + 'payment')">
                              {{$t('settingsOrdering.paymentOptionsErr')}}
                            </label>
                          </div>
                          <div class="form-group" v-if="order.type != 'delivery'">
                            <label>{{$t('settingsOrdering.minimumOrderValue')}}</label>
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'minimum_order_value'" 
                                    class="form-control sml"
                                    placeholder=""
                                    v-validate="{required: true, min_value: 0}"
                                    :disabled="!order.enabled"
                                    v-model="order.minimum_order_value"
                                    > <b>{{currency}}</b>
                          </div>
                          <div class="form-group" >
                            <label>{{$t('settingsOrdering.waitingTime')}}</label>  
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'default_waiting_time'" class="form-control sml" 
                                    v-model="order.default_waiting_time"
                                    :disabled="!order.enabled"
                                    placeholder=""
                                    v-validate="modelValidate.required">
                            <label>{{$t('settingsOrdering.minutes')}}</label>
                          </div>
                          <div class="form-group" v-if="order.type == 'eat_location'">
                            <label>Minim rezervari</label>  
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'min_reservation'" class="form-control sml" 
                                    v-model="order.min_reservation"
                                    :disabled="!order.enabled"
                                    placeholder=""
                                    v-validate="modelValidate.required">
                          </div>
                          <div class="form-group" v-if="order.type == 'eat_location'">
                            <label>Maxim rezervari</label>  
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'max_reservation'" class="form-control sml" 
                                    v-model="order.max_reservation"
                                    :disabled="!order.enabled"
                                    placeholder=""
                                    v-validate="modelValidate.required">
                          </div>
                          <div class="form-group">
                            <template v-if="order.type != 'self_ordering'">
                              <div class="form-group">
                                <label :for="'swPreorders_'+order.id" style="margin-right: 10px;">{{$t('settingsOrdering.noPreorders')}}</label>
                                <p-switch :name="'swPreorders_'+order.id" v-model="order.no_preorders" type="success"></p-switch>
                                <span v-if="order.offset > 0 || order.period > 1"> {{$t('settingsOrdering.offnoPreorders')}}</span>
                              </div>
                              <div class="form-group">
                                <label :for="'swAlwaysOpen_'+bussLocation.id+'_'+order.type" style="margin-right: 10px;">{{$t('settingsOrdering.isAlwaysOpen')}}</label>
                                <p-switch :name="'swAlwaysOpen_'+bussLocation.id+'_'+order.type" v-model="order.is_always_open" type="success"></p-switch>
                              </div>
                              <div class="form-group" v-if="order.is_always_open">
                                <label for="" style="margin-bottom: 12px;">
                                  {{$t('settingsOrdering.isAlwaysOpenPreorderHours')}}
                                  <input type="number"
                                    min="0"
                                    class="form-control"
                                    :name="bussLocation.id + order.type +'is_always_open_preorder_hours'"
                                    v-model="order.is_always_open_preorder_hours"
                                    :disabled="!order.enabled">
                                </label>
                              </div>
                              <label>{{$t('settingsOrdering.availableDays')}}</label>
                              <br/>
                              <label class="text-danger" v-show="errors.has(bussLocation.id + order.type + 'days')">
                                {{$t('settingsOrdering.availableDaysErr')}}
                              </label>
                              <div class="changeDeliveryDisponibility">
                                <div class="">
                                  <p-radio v-for="(dusg, dusgId) in delivery_hour_usage"
                                            v-if="order.type != 'eat_location' || (dusg.id != 2 && order.type === 'eat_location')"
                                            :key="dusgId"
                                            v-model="order.delivery_hour_usage"
                                            @input="changeDeliveryHourUsage(order)"
                                            :label="dusgId"
                                            :inline="true">{{$t('settingsOrdering')[dusg.name] }}
                                  </p-radio>
                                </div>
                                <hr />
                              </div>
                            </template>
                            <template v-if="!order.deactivate_delivery_hour_usage">
                              <template v-if="order.type != 'self_ordering'">
                                <label for="" style="margin-bottom: 12px; margin-right: 10px;">
                                  {{$t('settingsOrdering.offset')}}
                                  <input type="number"
                                      min="0"
                                      class="form-control"
                                      :name="bussLocation.id + order.type +'offset'"
                                      v-validate="modelValidate.offset"
                                      v-model="order.offset"
                                      :disabled="order.is_always_open">
                                </label>
                                <label for="" style="margin-bottom: 12px;">
                                  {{$t('settingsOrdering.period')}}
                                  <input type="number"
                                      min="1"
                                      class="form-control" 
                                      :name="bussLocation.id + order.type +'period'"
                                      v-validate="modelValidate.period"
                                      v-model="order.period"
                                      :disabled="order.is_always_open">
                                </label>
                              </template>
                              
                              <div class="row" v-for="(day, dayIdx) in order.available_days" style="display: flex; align-items: flex-start;     margin-bottom: 20px;">
                                <div class="col-md-6">
                                  <div class="row">
                                    <div class="col-md-3 padd in-inline-160">
                                      <div class="checkbox">
                                        <input v-if="dayIdx == 0" type="checkbox" 
                                                :value="day.day"
                                                v-model="day.open"
                                                :name="bussLocation.id + order.type + 'days'"
                                                :id="bussLocation.id + order.type + day.day"
                                                v-validate="{required: true}"
                                                :disabled="!order.enabled || order.is_always_open"
                                                >
                                        <input v-else  type="checkbox" 
                                                :value="day.day"
                                                v-model="day.open"
                                                :name="bussLocation.id + order.type + 'days'"
                                                :id="bussLocation.id + order.type + day.day"
                                                :disabled="!order.enabled || order.is_always_open"
                                                >
                                        <label :for="bussLocation.id + order.type + day.day">{{$t('days.' + day.day) | capitalize}}</label>
                                      </div>
                                    </div>
                                    <div class="col-md-9 padd">
                                      from
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="day.open_from"
                                                      v-model="day.open_from"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      to
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="day.open_to"
                                                      v-model="day.open_to"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                    </div>
                                  </div>
                                  <div class="row intervals" v-if="day.intervals">
                                    <template v-for="(interval, intervalKey) in day.intervals">
                                      <div class="col-md-3 padd in-inline-160"></div>
                                      <div class="col-md-9 padd">
                                      from
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="interval.open_from"
                                                      v-model="interval.open_from"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      to
                                      <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                      placeholder="Select time"
                                                      :value="interval.open_to"
                                                      v-model="interval.open_to"
                                                      v-validate="modelValidate.available_days"
                                                      :picker-options="pickerOptions">
                                      </el-time-select>
                                      <button class="btn btn-simple btn-icon " :disabled="order.is_always_open" @click.prevent="deleteIntervals(intervalKey, dayIdx, orderIdx, indexBussLocation)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button>
                                    </div>
                                    </template>
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <button class="btn btn-info btn-icon "
                                          @click.prevent="addMoreIntervals(dayIdx, orderIdx, indexBussLocation)"
                                          :disabled="order.is_always_open"
                                          :title="$t('general.add')  + ' moreIntervals'" >
                                    <i class="ti-plus"></i> 
                                  </button>
                                </div>
                              </div>
                            </template>
                          </div>
                          <div class="form-group">
                            <hr>
                          </div> 
                        </template>

                        <div class="row" v-if="order.type != 'self_ordering'">
                          <div class="col-md-12">
                            <div class="form-group">
                              <div class="card" style="box-shadow: none; border: 1px solid #dcdfe6;">
                                <div class="card-content">
                                  <div class="prod-tabs" direction="horizontal" type="tabs">
                                    <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                                      <h6>{{$t('settingsOrdering.infoBoxTitle')}}</h6>
                                      <button class="btn btn-info btn-icon "
                                              @click.prevent="addMethodInfo(orderIdx, indexBussLocation)"
                                              :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                                        <i class="ti-plus"></i>
                                      </button>
                                    </div>
                                    <div class="col-md-12 pad-lf-0 pad-rg-0">
                                      <hr class="sm">
                                    </div>
                                    <div :title="$t('catalogProdOpt.plural')" class="text-left">
                                      <div class="row">

                                        <div class="col-md-12" >
                                          <p v-if="!order.method_info || (order.method_info && order.method_info.length == 0)" class="">No options added yet.</p>
                                          <el-collapse ref="elColl" v-model="methodInfoIndex" accordion>
                                            <template v-for="(option, idxO) in order.method_info">
                                              <div class="align">
                                                <el-collapse-item class="customItem" :title="option.title === '' ? 'Name' : option.title" :name="idxO">
                                                  <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                                  <div class="row">
                                                    <div class="col-md-6">
                                                      <div class="form-group">
                                                        <label>{{$t('catalogProd.name')}}</label>
                                                        <input type="text"
                                                                name="name"
                                                                :placeholder="$t('catalogProd.name')"
                                                                v-validate="'required'"
                                                                v-model="option.title"
                                                                class="form-control">
                                                        <small class="text-danger" v-if="errors.has('name')">
                                                          {{ getError('name') }}
                                                        </small>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                      <div class="form-group">
                                                        <label>{{$t('settingsOrdering.infoBoxRadioCheck')}}</label>
                                                        <select class="form-control" v-model="option.type">
                                                          <option value="check">{{$t('settingsOrdering.infoBoxCheck')}}</option>
                                                          <option value="radio">{{$t('settingsOrdering.infoBoxRadio')}}</option>
                                                        </select>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <table class="table no-margin">
                                                    <thead>
                                                      <tr>
                                                        <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                                        <th>{{$t('general.delete')}}</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr v-for="(value, idx) in option.options">
                                                        <td>
                                                          <div class="row">
                                                            <div class="col-md-12">
                                                              <input type="text"
                                                                      class="form-control"
                                                                      v-model="value.title">
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td><button class="btn btn-simple btn-icon " @click.prevent="deleteMethodInfoOptionValue(orderIdx, indexBussLocation, idxO, idx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                  <div class="pull-right">
                                                    <button  class="btn btn-simple btn-icon mar-bt-5" @click.prevent="addMethodInfoOptionValue(orderIdx, indexBussLocation, idxO)">
                                                      <i class="ti-plus"></i> add
                                                    </button>
                                                  </div>
                                                </el-collapse-item>
                                                <div class="closeBtn">
                                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteMethodInfo(orderIdx, indexBussLocation, idxO)"><i class="ti-close"></i></button>
                                                </div>
                                              </div>
                                            </template>
                                          </el-collapse>
                                        </div>
                                        <div class="col-md-12 pad-to-15 pad-bt-10">
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="form-group">
                          <label>{{$t('settingsOrdering.paymentOptions')}}</label>

                          <div class="checkbox mar-bt-20" v-for="(opt, idx) in paymentOptions">
                            <input v-if="idx == 0" type="checkbox"
                                    :value="opt.payment_id"
                                    :name="bussLocation.id + order.type + 'payment'"
                                    :id="bussLocation.id + order.type + opt.payment_id"
                                    v-validate="{required: true}"
                                    v-model="order.payment_options[opt.payment_id]" 
                                    :disabled="!order.enabled"
                                    >
                            <input v-else  type="checkbox"
                                    :value="opt.payment_id"
                                    :name="bussLocation.id + order.type + 'payment'"
                                    :id="bussLocation.id + order.type + opt.payment_id"
                                    v-model="order.payment_options[opt.payment_id]" 
                                    :disabled="!order.enabled"
                                    >
                            <label :for="bussLocation.id + order.type + opt.payment_id">{{opt.name}}</label>
                          </div>
                          <label class="text-danger" v-show="errors.has(bussLocation.id + order.type + 'payment')">
                            {{$t('settingsOrdering.paymentOptionsErr')}}
                          </label>
                        </div>
                        <div class="form-group" v-if="order.type != 'delivery'">
                          <label>{{$t('settingsOrdering.minimumOrderValue')}}</label>
                          <input type="number"
                                  min="0"
                                  :name="bussLocation.id + order.type + 'minimum_order_value'" 
                                  class="form-control sml"
                                  placeholder=""
                                  v-validate="{required: true, min_value: 0}"
                                  :disabled="!order.enabled"
                                  v-model="order.minimum_order_value"
                                  > <b>{{currency}}</b>
                        </div>
                        <div class="form-group" >
                          <label>{{$t('settingsOrdering.waitingTime')}}</label>  
                          <input type="number"
                                  min="0"
                                  :name="bussLocation.id + order.type + 'default_waiting_time'" class="form-control sml" 
                                  v-model="order.default_waiting_time"
                                  :disabled="!order.enabled"
                                  placeholder=""
                                  v-validate="modelValidate.required">
                          <label>{{$t('settingsOrdering.minutes')}}</label>
                        </div>
                        <div class="form-group" >
                          <label>{{$t('settingsOrdering.count_orders_starts_from_hour')}}</label>  
                          <el-time-select :disabled="!order.enabled"
                                          placeholder="Select Hour"
                                          :value="order.count_orders_starts_from_hour"
                                          v-model="order.count_orders_starts_from_hour"
                                          :picker-options="picker_options_orders_starts_from">
                          </el-time-select>
                        </div>
                        <template v-if="order.type === 'delivery'">
                          <div class="row">
                            <div class="form-group col-sm-12" >
                              <label>{{$t('settingsOrdering.deliveryRules')}}</label>
                            </div>
                          </div>
                          <!-- here is section -->
                          <el-radio v-for="(zoneL, zoneId) in zoneLimitations"
                            :key="bussLocation.id + order.type + zoneId"
                            v-model="order.area"
                            :change="handleChangeArea(order.area, bussLocation.id)"
                            :label="zoneId"
                            :inline="true">{{$t('settingCompany.'+ zoneL)}}</el-radio>
                          <template v-if="order.area == 'radius'">
                            <delivery-tax-panel
                              v-if="taxesVersion === 2"
                              class="mar-bt-20"
                              :location-id="bussLocation.true_id || bussLocation.location_id || bussLocation.id"
                              :currency="currency"
                            ></delivery-tax-panel>
                            <table class="table table-rules" :key="bussLocation.id+ idx + 'rule'" v-for="(rule, idx) in order.delivery_rules">
                              <thead>
                                <tr>
                                  <th width="15px"><b>{{(idx + 1)}}</b></th>
                                  <th width="" style="line-height:2">
                                    {{$t('settingsOrdering.deliveryRange')}} ({{$t('settingsOrdering.deliveryRangeUnit')}})

                                    <button v-if="order.delivery_rules.length > 1"
                                                    class="btn btn-danger btn-icon pull-right"
                                                    @click.prevent="removeRule(bussLocation.id, idx, order.type)">
                                                    <i :title="$t('general.remove')" class="ti-trash"></i> {{$t('general.remove')}}
                                    </button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody >
                                <tr >
                                  <td>
                                  </td>
                                  <td >
                                    <input type="number"
                                            min="0"
                                            :name="bussLocation.id + order.type +'delivery_range'+idx"
                                            :ref="bussLocation.id + order.type +'delivery_range'+idx"
                                            class="form-control sml"
                                            placeholder=""
                                            v-validate="{min_value: 0}"
                                            :disabled="!order.enabled"
                                            v-model="rule.delivery_range"
                                            :aria-invalid="errors.has(bussLocation.id + order.type +'delivery_range'+idx)"
                                            >

                                      <table class="table table-subrules" style="">
                                        <thead>
                                          <th>{{$t('settingsOrdering.shippingNeighborhoods')}}</th>
                                          <th>{{$t('settingsOrdering.shippingCities')}}</th>
                                          <th v-if="taxesVersion !== 2" width="10%">
                                            {{$t('settingsOrdering.shippingCost')}} ({{currency}})
                                          </th>
                                          <th v-if="taxesVersion !== 2" width="10%">
                                            {{$t('catalogCateg.vat')}} <small>({{$t('catalogCateg.included')}})</small>
                                          </th>
                                          <th v-if="taxesVersion !== 2" width="10%">
                                            {{$t('settingsOrdering.posId')}}
                                          </th>
                                          <th v-if="taxesVersion !== 2" width="10%">
                                            
                                            {{$t('settingsOrdering.minimumOrderValue')}} ({{currency}})
                                          </th>
                                          <th></th>
                                        </thead>
                                        <tr :key="bussLocation.id+ idx + idxSubrule + 'subrule'" v-for="(subrule, idxSubrule) in rule.subrules">
                                          <td class="display-text-white">
                                            <el-select
                                                v-model="subrule.neighborhoods"
                                                multiple
                                                filterable
                                                allow-create
                                                default-first-option
                                                :placeholder="$t('general.add')">
                                                <el-option
                                                  v-for="item in subrule.neighborhoods"
                                                  :key="item"
                                                  :label="item"
                                                  :value="item">
                                                </el-option>
                                              </el-select>
                                          </td>
                                          <td class="display-text-white">
                                        <!--    <template v-if="rule.subrules.length > 1 && (idxSubrule + 1) < rule.subrules.length">
                                              <el-select
                                                v-model="subrule.cities"
                                                multiple
                                                filterable
                                                allow-create
                                                default-first-option
                                                v-validate="{required: true}"
                                                :placeholder="$t('general.add')">
                                                <el-option
                                                  v-for="item in subrule.cities"
                                                  :key="item"
                                                  :label="item"
                                                  :value="item">
                                                </el-option>
                                              </el-select>
                                            </template> -->
                                            <template >
                                              <el-select
                                                v-model="subrule.cities"
                                                multiple
                                                filterable
                                                allow-create
                                                default-first-option
                                                :placeholder="$t('general.add')">
                                                <el-option
                                                  v-for="item in subrule.cities"
                                                  :key="item"
                                                  :label="item"
                                                  :value="item">
                                                </el-option>
                                              </el-select>
                                            </template>
                                          </td>
                                          <td v-if="taxesVersion !== 2">
                                            <input type="number"
                                                    min="0"
                                                    :name="bussLocation.id + order.type +'shipping_cost'+order.type+idx+idxSubrule"
                                                    class="form-control sml" 
                                                    placeholder="" 
                                                    v-validate="{required: true, min_value: 0}"
                                                    :disabled="!order.enabled"
                                                    v-model="subrule.shipping_cost"
                                                    > 
                                          </td>
                                          <td v-if="taxesVersion !== 2">
                                            <select v-model="subrule.tax_id"
                                                    class="form-control">
                                              <option value="null">{{ $t('vat.selectVat') }}</option>
                                              <option v-for="tax in vatOptions"
                                                v-if="bussLocation.id == tax.location_token"
                                                :value="tax.id"
                                              >{{tax.amount}}
                                              </option>
                                            </select>
                                          </td>
                                          <td v-if="taxesVersion !== 2">
                                            <input type="text"
                                                    :name="bussLocation.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule"
                                                    class="form-control sml" 
                                                    :placeholder="$t('settingsOrdering.posId')" 
                                                    :disabled="!order.enabled"
                                                    v-model="subrule.shipping_pos_id"
                                                    > 
                                          </td>
                                          <td v-if="taxesVersion !== 2">
                                            <input type="text"
                                                    :name="bussLocation.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule"
                                                    class="form-control sml" 
                                                    :placeholder="$t('settingsOrdering.minimumOrderValue')" 
                                                    v-validate="{required: true, min_value: 0}"
                                                    :disabled="!order.enabled"
                                                    v-model="subrule.min_order_value"
                                                    > 
                                          </td>
                                          <td>
                                            <button v-if="rule.subrules.length > 1"
                                                    class="btn btn-simple btn-icon"
                                                    @click.prevent="removeSubRule(bussLocation.id, idx, idxSubrule,order.type)">
                                                    <i :title="$t('general.remove')" class="ti-close text-danger"></i>
                                            </button>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td :colspan="taxesVersion === 2 ? 2 : 4"></td>
                                          <td><button :title="$t('general.add')" class="btn btn-icon btn-info" @click.prevent="addNewSubRule(bussLocation.id, order.type, idx)"><i class="ti-plus"></i> </button></td>
                                        </tr>
                                      </table>                      
                                  </td>
                                  
                                </tr>
                                
                              </tbody>
                            </table>
                            <button :title="$t('general.add')" class="btn btn-icon btn-info mar-bt-15 " @click.prevent="addNewRule(bussLocation.id, order.type)"><i class="ti-plus"></i> {{$t('settingsOrdering.addRange')}} </button><br/>
                          </template>
                          <template v-if="order.area == 'draw'">
                            <br>
                            <hr>
                            <el-collapse accordion v-model="model.locations_details[indexBussLocation].mapactive">
                              <draggable v-model="deliveryRanges[bussLocation.id]" :element="'div'">
                                <div v-for="(zone, indexZone) in deliveryRanges[bussLocation.id]">
                                  <div class="sortableRow" :key="indexZone">
                                    <el-collapse-item :title="zone.name == '' ? $t('settingsOrdering.newZone'):zone.name" :name="indexZone">
                                      <template v-if="model.locations_details[indexBussLocation].mapactive == indexZone"> 
                                        <delivery-google-maps
                                        :googleMapsapiKey="bussLocation.google_maps_api_key"
                                        :cityFromParent="model.locations_details[indexBussLocation].city"
                                        :locationMarker="{lat: bussLocation.lat, lng: bussLocation.lng, name: bussLocation.name}"
                                        :zoneInComp="zone"
                                        :deliveryRanges="deliveryRanges[bussLocation.id]"
                                        :indexZone="indexZone"
                                        :bussLocationId="bussLocation.id"
                                        :location_id="bussLocation.true_id || bussLocation.location_id || bussLocation.id"
                                        :orderType="order.type"
                                        :currency="currency"
                                        :vatOptions="vatOptions"
                                        :taxes-version="taxesVersion"
                                        ></delivery-google-maps>
                                      </template>
                                    </el-collapse-item>
                                  </div>
                                </div>
                              </draggable>
                            </el-collapse>

                            <hr>
                            <button class="btn btn-info" @click.prevent="addNewZone(bussLocation.id, order.type, indexBussLocation)"><i class="ti-plus"></i>{{$t('settingsOrdering.addZone')}}</button>
                            <br>

                          </template>
                          <br>
                          <!-- here is the end of section -->
                          <!-- <hr/> -->
                        </template>
                        <!-- <div style="clear:both"></div> -->
                        <!-- <div class="form-group mar-to-10" v-if="order.type === 'delivery'">
                          <label>{{$t('settingsOrdering.shippingTax')}}</label>
                          <v-select v-model="order.shipping_cost.taxes"
                                    multiple
                                    :options="taxesPerLocation[bussLocation.id]"
                                    value="id"
                                    label="name">
                          </v-select>
                        </div> -->
            
                        <div class="form-group" v-if="order.type === 'meet_half'">
                          <label>{{$t('settingsOrdering.locations')}}</label>
                          <table class="table">
                            <thead>
                                <tr>
                                  <th width="23%">{{$t('settingsOrdering.street')}}</th>
                                  <th width="23%">{{$t('settingsOrdering.city')}}</th>
                                  <th width="23%">{{$t('settingsOrdering.country')}}</th>
                                  <th width="23%">{{$t('settingsOrdering.state')}}</th>
                                  <th width="8%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(location, idx) in order.locations">
                                <td><input type="text"
                                            class="form-control"
                                            :name="bussLocation.id + order.type +'locationstr'+order.type+idx"
                                            :disabled="!order.enabled"
                                            v-validate="modelValidate.required"
                                            v-model="location.street"> </td>
                                <td><input type="text"
                                            class="form-control"
                                            :name="bussLocation.id + order.type +'locationcity'+order.type+idx"
                                            :disabled="!order.enabled"
                                            vv-validate="modelValidate.required"
                                            v-model="location.city"> </td>
                                <td>
                                  <select v-model="location.country"
                                          :name="bussLocation.id + order.type +'locationcountry'+order.type+idx"
                                          :disabled="!order.enabled"
                                          v-validate="modelValidate.required"
                                          class="select-primary form-control"
                                          @change="updateCountry(location)">
                                    <option v-for="country in defaults.countries"
                                            class="select-primary"
                                            :value="country.alpha2">{{country.name}}
                                    </option>
                                  </select>
                                </td>
                                <td>
                                  <template v-if="showStateDrop(location)">
                                      <select v-model="location.state_id"
                                            class="select-primary form-control">
                                        <option v-for="state in getStatesOptions(location)"
                                              class="select-primary"
                                              :value="state.id">{{state.name}}
                                        </option>
                                    </select>
                                  </template>
                                  <template v-else>
                                    <input type="text" v-model="location.state" name="state" :placeholder="$t('settingsOrdering.state')" class="form-control" v-validate="modelValidate.required">
                                  </template>
                                </td>

                                <td><button class="btn btn-simple btn-icon" @click.prevent="removeLocation(bussLocation.id, idx, order.type)"><i :title="$t('general.remove')" class="ti-close text-danger"></i></button></td> 
                              </tr>
                              <template>
                                <tr >
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td><button :title="$t('general.add')" class="btn btn-icon btn-info" @click.prevent="addNewLocation(bussLocation.id, order.type)"><i class="ti-plus"></i></button></td>
                                </tr>
                              </template>
                            </tbody>
                            <tfoot></tfoot>
                          </table>
                        </div>
                        <div class="form-group">
                          <template v-if="order.type == 'self_ordering'">
                            <div class="form-group" >
                            <label>{{$t('settingsOrdering.maxDistanceInMeter')}}</label>  
                            <input type="number"
                                    min="0"
                                    :name="bussLocation.id + order.type + 'max_distance_in_meter'" class="form-control sml"
                                    v-model="order.max_distance_in_meter"
                                    :disabled="!order.enabled"
                                    placeholder=""
                                    v-validate="modelValidate.required">
                          </div>
                          </template>
                          <template v-if="order.type != 'self_ordering'">
                            <div class="form-group">
                              <label :for="'swPreorders_'+order.id" style="margin-right: 10px;">{{$t('settingsOrdering.noPreorders')}}</label>
                              <p-switch :name="'swPreorders_'+order.id" v-model="order.no_preorders" type="success"></p-switch>
                              <span v-if="order.offset > 0 || order.period > 1"> {{$t('settingsOrdering.offnoPreorders')}}</span>
                            </div>
                            <div class="form-group">
                              <label :for="'swAlwaysOpen_'+bussLocation.id+'_'+order.type" style="margin-right: 10px;">{{$t('settingsOrdering.isAlwaysOpen')}}</label>
                              <p-switch :name="'swAlwaysOpen_'+bussLocation.id+'_'+order.type" v-model="order.is_always_open" type="success"></p-switch>
                            </div>
                            <div class="form-group" v-if="order.is_always_open">
                              <label for="" style="margin-bottom: 12px;">
                                {{$t('settingsOrdering.isAlwaysOpenPreorderHours')}}
                                <input type="number"
                                  min="0"
                                  class="form-control"
                                  :name="bussLocation.id + order.type +'is_always_open_preorder_hours'"
                                  v-model="order.is_always_open_preorder_hours"
                                  :disabled="!order.enabled">
                              </label>
                            </div>
                            <label>{{$t('settingsOrdering.availableDays')}}</label>
                            <br/>
                            <label class="text-danger" v-show="errors.has(bussLocation.id + order.type + 'days')">
                              {{$t('settingsOrdering.availableDaysErr')}}
                            </label>
                            <div class="changeDeliveryDisponibility">
                              <div class="">
                                <p-radio v-for="(dusg, dusgId) in delivery_hour_usage"
                                          v-if="order.type != 'eat_location' || (dusg.id != 2 && order.type === 'eat_location')"
                                          :key="dusgId"
                                          v-model="order.delivery_hour_usage"
                                          @input="changeDeliveryHourUsage(order)"
                                          :label="dusgId"
                                          :inline="true">{{$t('settingsOrdering')[dusg.name] }}
                                </p-radio>
                              </div>
                              <hr />
                            </div>
                          </template>
                          <template v-if="!order.deactivate_delivery_hour_usage">
                            <template v-if="order.type != 'self_ordering'">
                              <label for="" style="margin-bottom: 12px; margin-right: 10px;">
                                {{$t('settingsOrdering.offset')}}
                                <input type="number"
                                    min="0"
                                    class="form-control"
                                    :name="bussLocation.id + order.type +'offset'"
                                    v-validate="modelValidate.offset"
                                    v-model="order.offset"
                                    :disabled="order.is_always_open">
                              </label>
                              <label for="" style="margin-bottom: 12px;">
                                {{$t('settingsOrdering.period')}}
                                <input type="number"
                                    min="1"
                                    class="form-control" 
                                    :name="bussLocation.id + order.type +'period'"
                                    v-validate="modelValidate.period"
                                    v-model="order.period"
                                    :disabled="order.is_always_open">
                              </label>
                            </template>
                            
                            <div class="row" v-for="(day, dayIdx) in order.available_days" style="display: flex; align-items: flex-start;     margin-bottom: 20px;">
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-3 padd in-inline-160">
                                    <div class="checkbox">
                                      <input v-if="dayIdx == 0" type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="bussLocation.id + order.type + 'days'"
                                              :id="bussLocation.id + order.type + day.day"
                                              v-validate="{required: true}"
                                              :disabled="!order.enabled || order.is_always_open"
                                              >
                                      <input v-else  type="checkbox" 
                                              :value="day.day"
                                              v-model="day.open"
                                              :name="bussLocation.id + order.type + 'days'"
                                              :id="bussLocation.id + order.type + day.day"
                                              :disabled="!order.enabled || order.is_always_open"
                                              >
                                      <label :for="bussLocation.id + order.type + day.day">{{$t('days.' + day.day) | capitalize}}</label>
                                    </div>
                                  </div>
                                  <div class="col-md-9 padd">
                                    from
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="day.open_from"
                                                    v-model="day.open_from"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    to
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="day.open_to"
                                                    v-model="day.open_to"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                  </div>
                                </div>
                                <div class="row intervals" v-if="day.intervals">
                                  <template v-for="(interval, intervalKey) in day.intervals">
                                    <div class="col-md-3 padd in-inline-160"></div>
                                    <div class="col-md-9 padd">
                                    from
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="interval.open_from"
                                                    v-model="interval.open_from"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    to
                                    <el-time-select :disabled="!day.open || !order.enabled || order.is_always_open"
                                                    placeholder="Select time"
                                                    :value="interval.open_to"
                                                    v-model="interval.open_to"
                                                    v-validate="modelValidate.available_days"
                                                    :picker-options="pickerOptions">
                                    </el-time-select>
                                    <button class="btn btn-simple btn-icon " :disabled="order.is_always_open" @click.prevent="deleteIntervals(intervalKey, dayIdx, orderIdx, indexBussLocation)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button>
                                  </div>
                                  </template>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <button class="btn btn-info btn-icon "
                                        @click.prevent="addMoreIntervals(dayIdx, orderIdx, indexBussLocation)"
                                        :disabled="order.is_always_open"
                                        :title="$t('general.add')  + ' moreIntervals'" >
                                  <i class="ti-plus"></i> 
                                </button>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="form-group">
                          <hr>
                        </div>
                        <div class="row" v-if="order.type != 'self_ordering'">
                          <div class="col-md-6">
                            <div class="form-group">
                              <div class="card" style="box-shadow: none; border: 1px solid #dcdfe6;">
                                <div class="card-content">
                                  <div class="prod-tabs" direction="horizontal" type="tabs">
                                    <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                                      <h6>{{$t('settingsOrdering.infoBoxTitle')}}</h6>
                                      <button class="btn btn-info btn-icon "
                                              @click.prevent="addMethodInfo(orderIdx, indexBussLocation)"
                                              :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                                        <i class="ti-plus"></i>
                                      </button>
                                    </div>
                                    <div class="col-md-12 pad-lf-0 pad-rg-0">
                                      <hr class="sm">
                                    </div>
                                    <div :title="$t('catalogProdOpt.plural')" class="text-left">
                                      <div class="row">

                                        <div class="col-md-12" >
                                          <p v-if="!order.method_info || (order.method_info && order.method_info.length == 0)" class="">No options added yet.</p>
                                          <el-collapse ref="elColl" v-model="methodInfoIndex" accordion>
                                            <template v-for="(option, idxO) in order.method_info">
                                              <div class="align">
                                                <el-collapse-item class="customItem" :title="option.title === '' ? 'Name' : option.title" :name="idxO">
                                                  <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                                  <div class="row">
                                                    <div class="col-md-6">
                                                      <div class="form-group">
                                                        <label>{{$t('catalogProd.name')}}</label>
                                                        <input type="text"
                                                                name="name"
                                                                :placeholder="$t('catalogProd.name')"
                                                                v-validate="'required'"
                                                                v-model="option.title"
                                                                class="form-control">
                                                        <small class="text-danger" v-if="errors.has('name')">
                                                          {{ getError('name') }}
                                                        </small>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                      <div class="form-group">
                                                        <label>{{$t('settingsOrdering.infoBoxRadioCheck')}}</label>
                                                        <select class="form-control" v-model="option.type">
                                                          <option value="check">{{$t('settingsOrdering.infoBoxCheck')}}</option>
                                                          <option value="radio">{{$t('settingsOrdering.infoBoxRadio')}}</option>
                                                        </select>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <table class="table no-margin">
                                                    <thead>
                                                      <tr>
                                                        <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                                        <th>{{$t('general.delete')}}</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr v-for="(value, idx) in option.options">
                                                        <td>
                                                          <div class="row">
                                                            <div class="col-md-12">
                                                              <input type="text"
                                                                      class="form-control"
                                                                      v-model="value.title">
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td><button class="btn btn-simple btn-icon " @click.prevent="deleteMethodInfoOptionValue(orderIdx, indexBussLocation, idxO, idx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                  <div class="pull-right">
                                                    <button  class="btn btn-simple btn-icon mar-bt-5" @click.prevent="addMethodInfoOptionValue(orderIdx, indexBussLocation, idxO)">
                                                      <i class="ti-plus"></i> add
                                                    </button>
                                                  </div>
                                                </el-collapse-item>
                                                <div class="closeBtn">
                                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteMethodInfo(orderIdx, indexBussLocation, idxO)"><i class="ti-close"></i></button>
                                                </div>
                                              </div>
                                            </template>
                                          </el-collapse>
                                        </div>
                                        <div class="col-md-12 pad-to-15 pad-bt-10">
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </form>
                  </el-collapse-item>
                  </template>
                </template>
              </el-collapse>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, TimeSelect} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'
  import DeliveryGoogleMaps from '../Maps/DeliveryGoogleMaps.vue'
  import DeliveryTaxPanel from '../Settings/Taxes/DeliveryTaxPanel.vue'
  import draggable from 'vuedraggable'
  Vue.component('v-select', vSelect)
  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      DeliveryGoogleMaps,
      DeliveryTaxPanel,
      PSwitch,
      draggable
    },
    computed: {
      ...mapFields(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])
    },
    props: {
      defaultData: {},
      modeldata: {},
      drawDetails: {},
      isDeliveryMethods: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      // isDeliveryMethods () {
      //   if (this.isDeliveryMethods) {
      //     this.getData()
      //   }
      // },
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        for (var iLocation in value.locations_details) {
          for (var iOrder in value.locations_details[iLocation].ordering_management) {
            // console.warn(iOrder)
            // set default value for locations
            if (value.locations_details[iLocation].ordering_management[iOrder].locations === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].locations = []
            }
            // set default value for interval_days_usage
            // if (value.locations_details[iLocation].ordering_management[iOrder].interval_days_usage === undefined) {
            //   Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'interval_days_usage', 1)
            // }
            // set default value for hour_and_day_delivery_hour_usage
            if (value.locations_details[iLocation].ordering_management[iOrder].period === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'period', 1)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].offset === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'offset', 0)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].no_preorders === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'no_preorders', false)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open', false)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open_preorder_hours === undefined) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open_preorder_hours', 0)
            }
            if (
              (value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage === undefined ||
                !value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage) &&
              (value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage === undefined ||
                !value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage) &&
              (value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage === undefined ||
               !value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage)
              ) {
              Vue.set(value.locations_details[iLocation].ordering_management[iOrder], 'delivery_hour_usage', 0)
              this.changeDeliveryHourUsage(value.locations_details[iLocation].ordering_management[iOrder])
            }
            // set default value for shipping cost object
            if (value.locations_details[iLocation].ordering_management[iOrder].shipping_cost === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].shipping_cost = []
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].delivery_rules === undefined) {
              let newRow = this.copyObject(this.newRule)
              let newSubRule = this.copyObject(this.newSubRule)
              newRow.subrules = []
              newRow.subrules.push(newSubRule)
              value.locations_details[iLocation].ordering_management[iOrder].delivery_rules = []
              value.locations_details[iLocation].ordering_management[iOrder].delivery_rules.push(newRow)
            }
            if (value.locations_details[iLocation].ordering_management[iOrder].area === undefined && value.locations_details[iLocation].ordering_management[iOrder].type === 'delivery') {
              value.locations_details[iLocation].ordering_management[iOrder].area = 'radius'
            }
            // set default values for the available days and hours objects
            for (var iDay in this.days) {
              var day = this.days[iDay]
              if (value.locations_details[iLocation].ordering_management[iOrder].available_days === undefined) {
                value.locations_details[iLocation].ordering_management[iOrder].available_days = []
              }
              var index = this.getObjectByElemKeyValue('day', day, value.locations_details[iLocation].ordering_management[iOrder].available_days)
              if (index === false) {
                value.locations_details[iLocation].ordering_management[iOrder].available_days.push({day: day, open_to: '', open_from: '', open: false})
              } else if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open === undefined) {
                if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_to !== '' &&
                    value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_from !== '') {
                  value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = true
                } else {
                  value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = false
                }
              }
            }
            // clean available days -- bug after days number got dubled because of translation
            let self = this
            value.locations_details[iLocation].ordering_management[iOrder].available_days = value.locations_details[iLocation].ordering_management[iOrder].available_days.filter(function (value, index, arr) {
              return (self.days.indexOf(value.day) !== -1)
            })
          }
        }
        this.model = value
        // var data = {
        //   token: this.$session.get('token'),
        //   company_id: this.$session.get('selectedCompany')
        // }
        // var self = this
        // // get taxes
        // this.apiRequest('/settings/taxes', 'GET', data, function (response) {
        //   if (response.status === true) {
        //     self.taxes = response.data
        //     let value = self.model
        //     let taxesPerLocation = []
        //     for (var iLocation in value.locations_details) {
        //       let ordMng = value.locations_details[iLocation].ordering_management
        //       for (var iOrder in ordMng) {
        //         if (ordMng[iOrder].type === 'delivery') {
        //           // check which taxes are enabled per a specific location
        //           taxesPerLocation[value.locations_details[iLocation].id] = []
        //           for (var iTax in value.locations_details[iLocation].taxes) {
        //             var iTaxData = self.getObjectByElemKeyValue('id', value.locations_details[iLocation].taxes[iTax].id, self.taxes)
        //             if (iTaxData !== false) {
        //               taxesPerLocation[value.locations_details[iLocation].id].push(self.taxes[iTaxData])
        //             }
        //           }
        //         }
        //       }
        //     }
        //     self.taxesPerLocation = taxesPerLocation
        //   }
        // })
      }
    },
    data () {
      return {
        reservationTaxesIndex: 0,
        methodInfoIndex: 0,
        delivery_hour_usage: [
          {
            'id': 0,
            'name': 'hourAndDate'
          },
          {
            'id': 1,
            'name': 'justDate'
          },
          {
            'id': 2,
            'name': 'deactivateDeliveryHours'
          }
        ],
        arrowsSimbolHtml: '<i style="cursor: move" class="fa fa-arrows sortHandle"></i>',
        colapsedItem: null,
        model: this.value || this.modeldata,
        deliveryRanges: [],
        defaults: this.value || this.defaultData, // this.countries
        pickerOptions1: {},
        pickerOptionsTaxFrom: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        pickerOptionsTaxTo: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        tabIndex: 0,
        taxes: [],
        taxesPerLocation: [],
        activeNames: [],
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        modelValidate: {
          'available_days': { required: true },
          'required': { required: true },
          'offset': { required: true, min_value: 0, max_value: 365, decimal: 0 },
          'period': { required: true, min_value: 1, max_value: 1095, decimal: 0 }
        },
        paymentOptions: [
          {
            'payment_id': 'credit_card',
            'name': this.$t('paymentTypes.CARD')
          },
          {
            'payment_id': 'cash',
            'name': this.$t('paymentTypes.CASH')
          },
          {
            'payment_id': 'pos',
            'name': this.$t('paymentTypes.POS')
          }
        ],
        pickerNames: ['date_from', 'date_to'],
        days: [
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
          'sunday'
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        },
        picker_options_orders_starts_from: {
          start: '00:00',
          step: '01:00',
          end: '24:00'
        },
        newLocation: {
          street: '',
          city: '',
          state: '',
          country: ''
        },
        newRule: {
          delivery_range: '',
          subrules: []
        },
        newSubRule: {
          shipping_cost: 0,
          shipping_pos_id: '',
          cities: [],
          neighborhoods: [],
          min_order_value: 0
        },
        zoneLimitations: {
          'radius': 'setRadiusArea',
          'draw': 'setDrawArea'
        },
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true,
        vatOptions: [],
        taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1)
      }
    },
    mounted () {
      this.getVatOptions()
      this.$nextTick(() => {
        this.doHeightCalculation()
        this.loading = false
        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
      if (this.isDeliveryMethods) {
        this.getData()
      }
    },
    methods: {
      getVatOptions (locaitonIds = null) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locaitonIds
        }
        this.apiRequest('/location/vat', 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptions = response.data
          }
        })
      },
      getData () {
        this.getDeliveryRanges()
        this.$bus.$on('drawingDetails', this.drawing) // listener for event from map
        this.$bus.$on('changeDeliveryZone', this.changeDeliveryZone) // listener for event from map
        this.currency = this.getCurrencySymbol(this.currency)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      getDeliveryRanges () {
        var data = {
          token: this.$session.get('token')
        }
        this.apiRequest('/settings/delivery-ranges', 'GET', data, (response) => {
          if (response.status === true) {
            this.deliveryRanges = response.data
          }
        })
      },
      validate () {
        var self = this
        this.errors.clear()
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            // first do the manual validation of ranges
            // this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules
            for (let bussL of this.model.locations_details) {
              for (let oIdx in bussL.ordering_management) {
                let o = bussL.ordering_management[oIdx]
                if (o.type === 'delivery') {
                  if (o.delivery_rules && o.delivery_rules.length > 1) {
                    // make sure all range values are filled in AND no two same values are used
                    for (let rIdx in o.delivery_rules) {
                      let rule = o.delivery_rules[rIdx]
                      if (rule.delivery_range.trim() === '') {
                        this.$nextTick().then(function () {
                          self.errors.add(bussL.id + o.type + 'delivery_range' + rIdx, 'invalid')
                          isValid = false
                        })
                      } else {
                        for (let r2Idx in o.delivery_rules) {
                          let rule2 = o.delivery_rules[r2Idx]
                          if (rule.delivery_range === rule2.delivery_range && rIdx !== r2Idx) {
                            this.$nextTick().then(function () {
                              self.errors.add(bussL.id + o.type + 'delivery_range' + rIdx, 'invalid')
                              self.errors.add(bussL.id + o.type + 'delivery_range' + r2Idx, 'invalid')
                              isValid = false
                            })
                          }
                        }
                      }
                    }
                  }
                  // validate locations
                  if (o.delivery_rules && o.delivery_rules.length && o.enabled) {
                    let uniqueCities
                    for (let rIdx3 in o.delivery_rules) {
                      if (o.delivery_rules[rIdx3].subrules !== undefined && o.delivery_rules[rIdx3].subrules.length > 1) {
                        uniqueCities = []
                        let subrules = o.delivery_rules[rIdx3].subrules
                        for (let subrule of subrules) {
                          if (subrule.cities.length) {
                            for (let city of subrule.cities) {
                              if (uniqueCities.indexOf(city) > -1 && (subrule.neighborhoods === undefined || !subrule.neighborhoods.length)) {
                                swal({'text': self.$t('settingsOrdering.citiesValidationError'), 'type': 'error', 'showConfirmButton': true}).catch(() => {})
                                this.$nextTick().then(function () {
                                  isValid = false
                                })
                                return false
                              } else {
                                uniqueCities.push(city)
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          this.$nextTick().then(function () {
            if (isValid) {
              self.saveDetails()
            } else {
              // this.activeNames = []
              // check which tabs have errors
              for (var bussLocation of self.model.locations_details) {
                for (var order of bussLocation.ordering_management) {
                  var tabTtl = bussLocation.id + order.type
                  if (order.enabled && self.errors.items.length) {
                    // check this.errors.items
                    for (var err of self.errors.items) {
                      if (err.field.includes(tabTtl)) {
                        self.activeNames.push(tabTtl)
                      }
                    }
                  }
                }
              }
              swal({'text': self.$t('settingsOrdering.notice'), 'type': 'error'})
            }
          })
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      showStateDrop (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return true
        } else {
          return false
        }
      },
      getStatesOptions (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return countries[countryIdx].states
        } else {
          return []
        }
      },
      updateCountry (location) {
        location.state = null
        location.state_id = null
      },
      addNewLocation (locId, type) {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = []
            newRow = self.copyObject(self.newLocation)
            newRow.id = response.data[0].id
            var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details)
            var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management)
            self.model.locations_details[locIdx].ordering_management[typeIdx].locations.push(newRow)
            // console.warn(self.model[typeIdx].locations)
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      addNewRule (locId, type) {
        this.$nextTick(function () {
          var self = this
          let newRow = []
          newRow = this.copyObject(self.newRule)
          let newSubRule = this.copyObject(self.newSubRule)
          var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details)
          var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management)
          this.$nextTick().then(function () {
            // newRow.shipping_cost = 0
            newRow.subrules = []
            newRow.subrules.push(newSubRule)
            if (self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules) {
              self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules.push(newRow)
            } else {
              self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules = []
              self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules.push(newRow)
            }
          })
        })
      },
      addNewSubRule (locId, type, idx) {
        this.$nextTick(function () {
          var self = this
          let newRow = []
          newRow = this.copyObject(self.newSubRule)
          var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details)
          var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management)
          let subrules = this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules']
          // console.warn(subrules)
          this.$nextTick().then(function () {
            if (subrules) {
              self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow)
            } else {
              self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules'] = []
              self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow)
            }
          })
        })
      },
      updateTabs (name, enabled) {
        this.$nextTick(function () {
          if (!enabled) {
            this.activeNames = [name]
          } else {
            this.activeNames = []
          }
        })
      },
      removeLocation (locId, idx, type) {
        // var iOrder = this.getObjectByElemKeyValue('type', type, this.model)
        var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management)
        this.model.locations_details[locIdx].ordering_management[typeIdx].locations.splice(idx, 1)
      },
      removeRule (locId, idx, type) {
        this.$nextTick(function () {
          var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
          var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management)
          this.$nextTick(function () {
            this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules.splice(idx, 1)
          })
        })
      },
      removeSubRule (locId, idx, idxSubrule, type) {
        this.$nextTick(function () {
          var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
          var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management)
          this.$nextTick(function () {
            this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx].subrules.splice(idxSubrule, 1)
            // console.warn(this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx])
          })
        })
      },
      saveDetails () {
        this.$nextTick(function () { this.loading = true })
        var companyID = this.$session.get('selectedCompany')
        var currentLocations = []
        var countries = this.$session.get('defaultData').countries
        for (var locIdx in this.model.locations_details) {
          var locData = this.copyObject(this.model.locations_details[locIdx])
          for (var orMngIdx in locData.ordering_management) {
            if (
              locData.ordering_management[orMngIdx].type === 'eat_location' &&
              this.model.locations_details[locIdx].ordering_management[orMngIdx].delivery_hour_usage === 2 &&
              this.model.locations_details[locIdx].ordering_management[orMngIdx].deactivate_delivery_hour_usage
            ) {
              locData.ordering_management[orMngIdx].deactivate_delivery_hour_usage = 0
              locData.ordering_management[orMngIdx].delivery_hour_usage = 0
              locData.ordering_management[orMngIdx].hour_and_date_delivery_hour_usage = 1
            }
            if (locData.ordering_management[orMngIdx].type === 'meet_half') {
              for (var idx in locData.ordering_management[orMngIdx].locations) {
                let countryIso = locData.ordering_management[orMngIdx].locations[idx].country
                let countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
                let states = []
                if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
                  states = countries[countryIdx].states
                }
                if (states.length && locData.ordering_management[orMngIdx].locations[idx].state_id) {
                  var state = this.getObjectByElemKeyValue('id', locData.ordering_management[orMngIdx].locations[idx].state_id, states)
                  if (state !== undefined) {
                    locData.ordering_management[orMngIdx].locations[idx].state = states[state].name
                  } else {
                    locData.ordering_management[orMngIdx].locations[idx].state = null
                  }
                }
                delete locData.ordering_management[orMngIdx].locations[idx].states
              }
            }
          }
          currentLocations[locIdx] = locData
        }

        var data = {
          'token': this.$session.get('token'),
          'locations_details': JSON.stringify(currentLocations),
          'delivery_options_labels': JSON.stringify(this.model.delivery_options_labels),
          'delivery_ranges': JSON.stringify(this.deliveryRanges)
        }
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, (response) => {
          if (response.status === true) {
            this.$nextTick(function () {
              this.loading = false
              this.$session.set('selectedCompanyData', this.buildCompanySessionData(response.data[0]))
              this.model.locations_details = response.data[0].locations_details
            })
            swal({'text': this.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000}).catch(() => {})
          } else {
            // self.handleErrors(response.errors)
            this.$nextTick(function () { this.loading = false })
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      drawing (obj) {},
      changeDeliveryZone (obj) {
        if (obj.action === 'delete') {
          this.deliveryRanges[obj.bussLocationId].splice(obj.indexZone, 1)
        }
      },
      addNewZone (locId, type, locIdx) {
        this.pushEmptyDeliveryZones(locId, locIdx)
      },
      pushEmptyDeliveryZones (locId, locIdx) {
        if (!this.deliveryRanges.hasOwnProperty(locId)) {
          this.deliveryRanges[locId] = []
        }
        let length = this.deliveryRanges[locId].push({
          'name': '',
          'shape': {}
        })
        if (locIdx) {
          this.model.locations_details[locIdx].mapactive = (length - 1)
        }
      },
      handleChangeArea (area, locId) {
        // console.warn(area)
        // console.warn(locId)
        this.$nextTick(() => {
          if (area === 'draw') {
            if (!this.deliveryRanges.hasOwnProperty(locId)) {
              this.deliveryRanges[locId] = []
            }
            if (!this.deliveryRanges[locId].length) {
              this.pushEmptyDeliveryZones(locId)
            }
          }
        })
      },
      addMethodInfo (orderIdx, indexBussLocation) {
        let newRow = {
          'title': '',
          'type': 'check',
          'options': []
        }

        if (!this.model.locations_details[indexBussLocation].ordering_management[orderIdx].hasOwnProperty('method_info')) {
          Vue.set(this.model.locations_details[indexBussLocation].ordering_management[orderIdx], 'method_info', [])
        }

        this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info.push(newRow)

        this.methodInfoIndex = this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info ? this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info.length - 1 : 0
      },
      deleteMethodInfo (orderIdx, indexBussLocation, id) {
        swal({
          text: this.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            this.methodInfoIndex = this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info.splice(id, 1)
          }
        })
      },
      addMethodInfoOptionValue (orderIdx, indexBussLocation, optIdx) {
        let newRow = {
          'title': ''
        }
        this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info[optIdx].options.push(newRow)
        // Vue.set(this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info[optIdx], 'options', newRow)
      },
      deleteMethodInfoOptionValue (orderIdx, indexBussLocation, optIdx, idx) {
        this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info[optIdx].options.splice(idx, 1)
      },
      changeDeliveryHourUsage (order) {
        order.hour_and_date_delivery_hour_usage = false
        order.just_date_delivery_hour_usage = false
        order.deactivate_delivery_hour_usage = false
        // order.next_day_delivery_hour_usage = false
        switch (order.delivery_hour_usage) {
          case 0:
            order.hour_and_date_delivery_hour_usage = true
            break
          case 1:
            order.just_date_delivery_hour_usage = true
            break
          default:
            order.deactivate_delivery_hour_usage = true
        }
      },
      addMoreIntervals (dayIdx, orderIdx, indexBussLocation) {
        let index = 0
        if (!this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].hasOwnProperty('intervals')) {
          Vue.set(this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx], 'intervals', [])
        } else {
          index = this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].intervals.length
        }
        const newObj = {
          'open_from': '',
          'open_to': ''
        }
        Vue.set(this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].intervals, index, newObj)
      },
      deleteIntervals (intervalKey, dayIdx, orderIdx, indexBussLocation) {
        this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].intervals.splice(intervalKey, 1)
      },
      addReservationTaxesInfo (indexBussLocation, orderIdx) {
        this.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes.push({
          'id': 0,
          'name': 'Rezervare',
          'price': 0,
          'table_zone_id': 0,
          'date_from': '',
          'date_to': '',
          'deleted_at': null
        })
      },
      deleteReservationTaxesInfo (indexBussLocation, orderIdx, idTax) {
        swal({
          text: this.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            if (this.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes[idTax].id) {
              this.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes[idTax].deleted_at = 1
            } else {
              this.reservationTaxesIndex = this.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes.splice(idTax, 1)
            }
          }
        })
      },
      goToCompany () {
        this.$session.set('selectedTab', this.$t('settingsPages.locationGroups'))
        window.location.reload(true)
      }
    }
  }
</script>
<style lang="scss">
  .customItem {
    display: flex;
    justify-content: flex-start;
    flex-direction: column; 
    width: 90%;
  }
  .align {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .closeBtn {
    margin-top: 10px;
    width: 10%;
    display: flex;
  }
  .changeDeliveryDisponibility {
    .radio {
      label::before,
      label::after {
        top: 0;
        line-height: 1;
      }
    }
  }
</style>
<style>
  .el-date-editor.el-input{ max-width: 170px; }
  .padd{ padding: 4px 15px; }
  .company-details .sortableRow .el-collapse-item__header:before {
    content: "\f047";
    width: 21px;
    text-align: center;
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-right: 7px;
    cursor: move;
  }
</style>
 <style scoped lang="scss">
  .changeDeliveryDisponibility {
    display: flex;
    align-items: center;
    .checkbox {
      margin: 10px;
      margin-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/OrderingManagement/OrderingManagement.vue